import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import React from "react";

interface StepProps {
	addSeparator: boolean;
	active: boolean;
	label: string;
}

export const RegisterProgressionStep = ({ addSeparator, active, label }: StepProps): JSX.Element => (
	<>
		{addSeparator && <StepSeparator active={active} />}
		<StepContainer>
			<Dot active={active} />
			<Label className="p-size-xs-semi-bold" active={active}>
				{label}
			</Label>
		</StepContainer>
	</>
);

const StepSeparator = styled.div<{ active: boolean }>`
	background-color: ${({ active }) => (active ? colors.primary : colors.grey25)};
	height: 2px;
	width: 100%;
	max-width: 320px;
`;

const StepContainer = styled.div`
	position: relative;
`;

const Label = styled.div<{ active: boolean }>`
	position: absolute;
	text-align: center;
	left: 50%;
	transform: translateX(-50%);
	white-space: nowrap;
	color: ${({ active }) => (active ? colors.primary : colors.grey80)};
`;

const Dot = styled.div<{ active: boolean }>`
	height: 8px;
	width: 8px;
	border-radius: 100%;
	background-color: ${({ active }) => (active ? colors.primary : colors.grey)};
`;
